@if(pin && pin.length > 0){
<div
    class="flex flex-column gap-3 justify-content-center pin-view-container align-content-center align-items-center text-center">
    <div>
        <span class="title">
            <app-translate key="PIN_VERIFICATION"></app-translate>
        </span>
    </div>
    <div>
        <span class="sub-title">
            <app-translate key="PROVIDE_PIN"></app-translate>
        </span>
    </div>
    <div>
        <span class="pin">
            {{pin}}
        </span>
    </div>
    <div>
        <span class="sub-title">
            <app-translate key="AUTO_REFRESH"></app-translate>
        </span>
    </div>
</div>
}